export type RadishRuntimeConfig = {
  bffBaseUrl?: string;
};

declare global {
  interface Window {
    __RADISH_CONFIG__?: RadishRuntimeConfig;
  }
}

const DEFAULT_BFF_BASE_URL = '/api';

export function getBffBaseUrl(): string {
  const baseUrl = window.__RADISH_CONFIG__?.bffBaseUrl?.trim() || DEFAULT_BFF_BASE_URL;
  const normalized = baseUrl.replace(/\/+$/, '');
  return normalized || DEFAULT_BFF_BASE_URL;
}

export function apiUrl(path: string): string {
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${getBffBaseUrl()}${suffix}`;
}
